import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { Subtitle, Title } from 'pages/Configurations/Users/styles'
import { IoCloseSharp } from 'react-icons/io5'
import { InputLabel } from 'components/InputLabel'
import { FieldValues, UseFormRegister } from 'react-hook-form'
import { dialogPanel, dialogTitle} from 'components/Ishikawa/style'
import {
  ActionButton,
  cancelButton,
  ContainerActionButtons,
  locatedErrorSyle,
  saveButton,
} from 'pages/Configurations/FormUser/styles'

interface NewSectorModalProps {
  isOpen: boolean
  isEditing: boolean
  register: UseFormRegister<FieldValues>
  handleSubmit: any
  handleAddCause: (data: { selectedValue: string }) => void
  handleAddDescription: (data: { selectedValue: string }) => void
  handleCloseModal: () => void
  categoryName?: string
  type?:string
}

const Modal: React.FC<NewSectorModalProps> = ({
  isOpen,
  isEditing,
  register,
  handleSubmit,
  handleAddCause,
  handleAddDescription,
  handleCloseModal,
  categoryName,
  type
}) => {
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          onSubmit={handleSubmit(type === 'cause' ? (handleAddCause as any) : (handleAddDescription as any))}
          as='form'
          className='relative z-10'
          onClose={handleCloseModal}
        >
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bg-black bg-opacity-25' />
          </Transition.Child>

          <div
            data-testid="test-ishikawa-modal"
            className='fixed inset-0 overflow-y-auto'>
            <div className='flex min-h-full items-center justify-center p-4 text-center'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <Dialog.Panel className={dialogPanel}>
                  <Dialog.Title as='h3' className={dialogTitle}>
                    <div>
                      <Title className='font-bold'>
                      {((!isEditing) ? 
                      (type === 'cause') ? `Cadastrar nova causa` : 'Cadastrar descrição'
                      :
                      (type === 'cause') ? `Editar causa` : 'Editar descrição')}
                        </Title>
                      <Subtitle>
                      {((!isEditing) ? 
                      `Preencha os dados abaixo para cadastrar uma ${(type === 'cause') ? `causa` : 'descrição'} para categoria `
                      :
                      `Preencha os dados abaixo para editar a ${(type === 'cause') ? `causa` : 'descrição'} para categoria `)}
                      <b>{categoryName}</b>.
                      </Subtitle>
                    </div>
                    <IoCloseSharp
                      onClick={handleCloseModal}
                      className='text-blueTheme h-5 w-5 cursor-pointer'
                    />
                  </Dialog.Title>

                  <div className='mt-2 mb-[40px]'>
                  <InputLabel
                      label=''
                      name='selectedValue'
                      register={register}
                      className={false ? locatedErrorSyle : ''}
                      maxLength={50}
                      error={{
                        message: false
                          ? 'Desculpe, causa já cadastrada. Por favor, verifique e tente novamente.'
                          : '',
                      }}
                    />
                  </div>

                  <ContainerActionButtons>
                    <ActionButton
                      onClick={handleCloseModal}
                      className={cancelButton}
                    >
                      Cancelar
                    </ActionButton>
                      <ActionButton data-testid="test-submit-modal" className={saveButton}>Salvar</ActionButton>
                  </ContainerActionButtons>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}

export { Modal }